import { modalState } from 'models/modal';
import { commonState } from 'models';
import {
  MODAL_POPUP_ACTIONS, COUNTRIES_ACTIONS, SITES_ACTIONS
} from 'actions/common';
import { suffixFulfilled } from 'actions';

export const loadingReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return {};
  }
  const { type } = action;
  const isPFR = ['/pending', '/fulfilled', '/rejected'].some(s => type.includes(s));
  if (!isPFR) return state;
  const requestSplit = type.split('/');
  const requestState = requestSplit.pop();
  const requestName = `${requestSplit.join('/')}/`;
  return {
    ...state,
    [requestName]: requestState === 'pending'
  };
};

export const errorReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return {};
  }
  const { type, payload } = action;
  const isPFR = ['/pending', '/fulfilled', '/rejected'].some(s => type.includes(s));
  if (!isPFR) return state;
  const requestSplit = type.split('/');
  const requestState = requestSplit.pop();
  const requestName = `${requestSplit.join('/')}/`;

  return {
    ...state,
    [requestName]: requestState === 'rejected' ? payload.message : ''
  };
};

export const modalReducer = (
  state,
  action: { type: string, payload: {} }
) => {
  if (typeof state === 'undefined') {
    return modalState;
  }
  switch (action.type) {
    case MODAL_POPUP_ACTIONS.OPEN_MODAL_POPUP:
      return {
        ...state,
        modalProps: action.payload
      };
    case MODAL_POPUP_ACTIONS.CLOSE_MODAL_POPUP:
      return {
        ...state,
        modalProps: {}
      };
    default:
      return state;
  }
};


export const commonReducer = (
  state,
  action
) => {
  if (typeof state === 'undefined') {
    return commonState;
  }
  switch (action.type) {
    case COUNTRIES_ACTIONS.GET_COUNTRIES + suffixFulfilled:
      return {
        ...state, countries: action.payload
      };
    case COUNTRIES_ACTIONS.SET_COUNTRY + suffixFulfilled:
      return {
        ...state, selCountry: action.payload
      };
    case SITES_ACTIONS.GET_ALL_SITES + suffixFulfilled:
      return {
        ...state, allSites: action.payload
      };
    default:
      return state;
  }
};
